// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimsTeamAggregatorResponseDto } from './IClaimsTeamAggregatorResponseDto';
import {
    IClaimsTeamAggregatorResponseDtoFromJSON,
    IClaimsTeamAggregatorResponseDtoFromJSONTyped,
    IClaimsTeamAggregatorResponseDtoToJSON,
    IClaimsTeamAggregatorResponseDtoToJSONTyped,
} from './IClaimsTeamAggregatorResponseDto';
import type { IContactDataDto } from './IContactDataDto';
import {
    IContactDataDtoFromJSON,
    IContactDataDtoFromJSONTyped,
    IContactDataDtoToJSON,
    IContactDataDtoToJSONTyped,
} from './IContactDataDto';

/**
 * 
 * @export
 * @interface IClaimsResponseAggregatorDto
 */
export interface IClaimsResponseAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    category_type?: IClaimsResponseAggregatorDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDto
     */
    category_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    claim_status?: IClaimsResponseAggregatorDtoClaimStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IClaimsResponseAggregatorDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimsResponseAggregatorDto
     */
    updated_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    age?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    employee_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     * @deprecated
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {IContactDataDto}
     * @memberof IClaimsResponseAggregatorDto
     */
    assignee?: IContactDataDto;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    payment_type?: IClaimsResponseAggregatorDtoPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    escalation_note?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    contact_first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    contact_last_name?: string;
    /**
     * 
     * @type {Array<IClaimsTeamAggregatorResponseDto>}
     * @memberof IClaimsResponseAggregatorDto
     */
    claims_teams?: Array<IClaimsTeamAggregatorResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof IClaimsResponseAggregatorDto
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimsResponseAggregatorDto
     */
    provider_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimsResponseAggregatorDto
     */
    service_on?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimsResponseAggregatorDto
     */
    is_appealed?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IClaimsResponseAggregatorDto
     */
    appeal_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimsResponseAggregatorDto
     */
    is_organization_locked?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IClaimsResponseAggregatorDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IClaimsResponseAggregatorDtoClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimsResponseAggregatorDtoPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}


/**
 * Check if a given object implements the IClaimsResponseAggregatorDto interface.
 */
export function instanceOfIClaimsResponseAggregatorDto(value: object): value is IClaimsResponseAggregatorDto {
    return true;
}

export function IClaimsResponseAggregatorDtoFromJSON(json: any): IClaimsResponseAggregatorDto {
    return IClaimsResponseAggregatorDtoFromJSONTyped(json, false);
}

export function IClaimsResponseAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsResponseAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'category_id': json['category_id'] == null ? undefined : json['category_id'],
        'claim_status': json['claim_status'] == null ? undefined : json['claim_status'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'age': json['age'] == null ? undefined : json['age'],
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'assignee': json['assignee'] == null ? undefined : IContactDataDtoFromJSON(json['assignee']),
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'escalation_note': json['escalation_note'] == null ? undefined : json['escalation_note'],
        'contact_first_name': json['contact_first_name'] == null ? undefined : json['contact_first_name'],
        'contact_last_name': json['contact_last_name'] == null ? undefined : json['contact_last_name'],
        'claims_teams': json['claims_teams'] == null ? undefined : ((json['claims_teams'] as Array<any>).map(IClaimsTeamAggregatorResponseDtoFromJSON)),
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'is_appealed': json['is_appealed'] == null ? undefined : json['is_appealed'],
        'appeal_date': json['appeal_date'] == null ? undefined : (new Date(json['appeal_date'])),
        'is_organization_locked': json['is_organization_locked'] == null ? undefined : json['is_organization_locked'],
    };
}

export function IClaimsResponseAggregatorDtoToJSON(json: any): IClaimsResponseAggregatorDto {
    return IClaimsResponseAggregatorDtoToJSONTyped(json, false);
}

export function IClaimsResponseAggregatorDtoToJSONTyped(value?: IClaimsResponseAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'category_type': value['category_type'],
        'category_id': value['category_id'],
        'claim_status': value['claim_status'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'age': value['age'],
        'employee_name': value['employee_name'],
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'employer_name': value['employer_name'],
        'subsidiary_name': value['subsidiary_name'],
        'assignee': IContactDataDtoToJSON(value['assignee']),
        'payment_type': value['payment_type'],
        'external_identifier': value['external_identifier'],
        'escalation_note': value['escalation_note'],
        'contact_first_name': value['contact_first_name'],
        'contact_last_name': value['contact_last_name'],
        'claims_teams': value['claims_teams'] == null ? undefined : ((value['claims_teams'] as Array<any>).map(IClaimsTeamAggregatorResponseDtoToJSON)),
        'service_id': value['service_id'],
        'provider_name': value['provider_name'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString().substring(0,10)),
        'is_appealed': value['is_appealed'],
        'appeal_date': value['appeal_date'] == null ? undefined : ((value['appeal_date']).toISOString()),
        'is_organization_locked': value['is_organization_locked'],
    };
}

